module.exports = __webpack_public_path__ + "01_medium_black.d88b6aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_medium_black.png
// module id = g9S6
// module chunks = 0